import React, { Component, Fragment } from 'react'
import Header from '../components/header/header'
import Home from './home'
import Projects from './projects'
import About from './about'
import Footer from './footer'
import Contact from './contact'
import {dataAnglais,dataFrench} from "../jumbotron"


export default class Index extends Component {
    state={
        home:true,
        projects:false,
        about:false,
        contact:false,
        language:localStorage.getItem("languages")?localStorage.getItem("languages"):"en",
        mode:localStorage.getItem("mode")==="false"?false:true,
    }
  
    handleHome=()=>{this.setState({home:true,projects:false,about:false,contact:false})}
    handleProjects=()=>{this.setState({home:false,projects:true,about:false,contact:false})}
    handleAbout=()=>{this.setState({home:false,projects:false,about:true,contact:false})}
    handleContact=()=>{this.setState({home:false,projects:false,about:false,contact:true})}

    handleLanguage=(langue)=>{
        localStorage.setItem("languages",langue)
        this.setState({language:langue})
        console.log(localStorage.getItem("languages"))
    }
    handleMode=(modeDark)=>{
        localStorage.setItem("mode",modeDark)
        this.setState({mode:modeDark})
        console.log(localStorage.getItem("mode"))
    }

    render() {
        // console.log(localStorage.getItem("languages"))
        return (
            <Fragment>
                    <Header
                    handleHome={this.handleHome}
                    handleAbout={this.handleAbout}
                    handleContact={this.handleContact}
                    handleProjects={this.handleProjects}  
                    handleLanguage={this.handleLanguage}
                    language={this.state.language}  
                    handleMode={this.handleMode}
                    mode={this.state.mode}
                    home={this.state.home}
                    projects={this.state.projects}
                    about={this.state.about}
                    contact={this.state.contact}
                    jumbotron={this.state.language==="en"?dataAnglais:dataFrench}
                    />

                    {this.state.home?<Home 
                    handleLanguage={this.handleLanguage}  
                    handleAbout={this.handleAbout} 
                    handleContact={this.handleContact}
                    language={this.state.language}  
                    mode={this.state.mode}
                    jumbotron={this.state.language==="en"?dataAnglais:dataFrench}
                    />:null}
                    {this.state.projects?<Projects 
                    handleLanguage={this.handleLanguage}  
                    handleAbout={this.handleAbout}
                    language={this.state.language} 
                    mode={this.state.mode}
                    jumbotron={this.state.language==="en"?dataAnglais:dataFrench}
                    />:null}
                    {this.state.about?<About 
                    handleLanguage={this.handleLanguage}
                    language={this.state.language} 
                    mode={this.state.mode} 
                    jumbotron={this.state.language==="en"?dataAnglais:dataFrench}
                    />:null}
                    {this.state.contact?<Contact 
                    handleLanguage={this.handleLanguage}  
                    handleAbout={this.handleAbout}
                    language={this.state.language}  
                    mode={this.state.mode}
                    jumbotron={this.state.language==="en"?dataAnglais:dataFrench}
                    />:null}


                    <Footer
                        handleHome={this.handleHome}
                        handleAbout={this.handleAbout}
                        handleContact={this.handleContact}
                        handleProjects={this.handleProjects}    
                        home={this.state.home}
                        projects={this.state.projects}
                        about={this.state.about}
                        contact={this.state.contact}
                        mode={this.state.mode}
                        handleLanguage={this.handleLanguage}
                        language={this.state.language}  
                    />
            </Fragment>
        )
    }
}
